import React, { useRef } from "react";
import { useEffect, useContext } from "react";
import BruttoNettoContext from "../../BruttoNettoRechnerKomponenten/BruttoNettoContext";
import extSozVsgCalcSZ from "./extSozVsgCalcSZ_korr";
import extEStCalcSZ from "./extEStCalcSZ_korr";
import { Tooltip as ReactTooltip } from "react-tooltip";
export default function ErgSz14() {
  const { bruttoNettoState, handleBruttoNettoState } =
    useContext(BruttoNettoContext);
  const bruttoGehalt = bruttoNettoState.bruttoGehalt;

  const safeHandleBruttoNettoState = useRef(handleBruttoNettoState);

  useEffect(() => {
    console.log("useEffect running");
    const abgabenBerechnen = () => {
      console.log("bruttoGehalt", bruttoGehalt);
      const grenzbetrag = 12120;

      //auch hier ist mit den richtigen - HBGL berücksichtigenden - BGL zu hantieren!

      let bmgWG = 0;
      if (bruttoGehalt > grenzbetrag) {
        bmgWG = 0;
      } else {
        bmgWG = Math.min(bruttoGehalt, grenzbetrag - bruttoGehalt);
      }

      const { sVsgBeitrag: sVsgBeitragWG, sVsgSatz } = extSozVsgCalcSZ(bmgWG);

      safeHandleBruttoNettoState.current("sz14SVsgSatz", sVsgSatz.toFixed(2));
      safeHandleBruttoNettoState.current(
        "sz14SVsgBeitrag",
        sVsgBeitragWG.toFixed(2)
      );
      //ESt-Ermittlung
      // zunächst ist der SZSaldo von NettoUG und NettoWG zu bilden

      const nettoWG = bruttoGehalt - sVsgBeitragWG;

      // die Werte für das NettoUG sind erst zusätzlich auszurechnen
      const bmgUG = Math.min(grenzbetrag, bruttoGehalt);
      const { sVsgBeitrag: sVsgBeitragUG, sVsgSatzUG } = extSozVsgCalcSZ(bmgUG);

      let nettoUG = bruttoGehalt - sVsgBeitragUG;

      let SZNettoSaldo = nettoWG + nettoUG;
      //Einschleifregelung 2100 Freigrenze
      if (bruttoGehalt < 1050.01) {
        SZNettoSaldo = 0;
        nettoUG = 0;
      }
      // jetzt kann die Gesamt-Steuer für die SZ ermittelt werden
      const steuerSZSaldo = extEStCalcSZ(SZNettoSaldo, 0);
      //danach ist die Steur für das UG vom steuerSZ-Saldo abzuziehen
      const steuerSZUG = extEStCalcSZ(nettoUG, 0);
      const steuerSZ14 = steuerSZSaldo - steuerSZUG;

      safeHandleBruttoNettoState.current("steuerSZ14", steuerSZ14.toFixed(2));
      safeHandleBruttoNettoState.current(
        "nettoSZ14",
        (bruttoGehalt - sVsgBeitragWG - steuerSZ14).toFixed(2)
      );

      console.log(bruttoNettoState);

      //   safeHandleBruttoNettoState.current("steuer", gesamtSteuer.toFixed(2));
      //   safeHandleBruttoNettoState.current("sVsgBeitrag", sVsgBeitrag.toFixed(2));
      //   safeHandleBruttoNettoState.current("sVsgSatz", sVsgSatz.toFixed(2));
      //   safeHandleBruttoNettoState.current("nettoGehalt", nettoGehalt.toFixed(2));
    };

    abgabenBerechnen();
  }, [bruttoGehalt, safeHandleBruttoNettoState]);

  return (
    <>
      <p className="lead">
        <b>SZ 14. Monatslohn</b>
      </p>
      <div className="result trc2">
        SV-Satz
        <span className="tooltip" data-tooltip-id="tooltip8">
          {" "}
          ℹ️
        </span>
        :
        <span className="help_float_right">
          {bruttoNettoState.sz14SVsgSatz.toLocaleString("de-DE")}%
        </span>
      </div>
      <div className="result trc1">
        SV-Beitrag:
        <span className="help_float_right">
          {bruttoNettoState.sz14SVsgBeitrag.toLocaleString("de-DE")}€
        </span>
      </div>

      <div className="result trc2">
        Steuer
        <span className="tooltip" data-tooltip-id="tooltip9">
          {" "}
          ℹ️
        </span>
        :
        <span className="help_float_right">
          {bruttoNettoState.steuerSZ14.toLocaleString("de-DE")}€
        </span>
      </div>

      <div className="result net-pay trc1">
        netto:
        <span className="help_float_right">
          {" "}
          {bruttoNettoState.nettoSZ14.toLocaleString("de-DE")}€
        </span>
        <ReactTooltip id="tooltip8" place="bottom" variant="info">
          <span style={{ "font-weight": "normal" }}>
            <p>Keine LAK-Umlage bei SZ.</p>
          </span>
        </ReactTooltip>
        <ReactTooltip id="tooltip9" place="bottom" variant="info">
          <span style={{ "font-weight": "normal" }}>
            <p>Jahressechstel (SZ 13 & 14):</p>
            <p>620€ Freibetrag</p>
            <p> 2.100€ Freigrenze </p>
            <p>günstige 6%-Besteuerung bis 25.000€</p>
          </span>
        </ReactTooltip>
      </div>
    </>
  );
}
